export default __webpack_public_path__ + "static/media/bannersideimage.93c55ec9.svg";